/* eslint-disable */

if ('dev' === 'dev') {
  window.fetch = undefined; // hacky fix for native fetch that fails on pretenderjs: https://github.com/pretenderjs/pretender/issues/60
}



// WEBPACK FOOTER //
// ./js/utils/check-fetch.js